import React from 'react'
import Header from '../../Header'
import { buttons } from '../../../helpers/const'
import Error from '../../form/error'
import Modal from '../../Modal'

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSubscription: null,
      show: false,
    };
  }

  setSelectedSubscription = (id) => { this.setState({ selectedSubscription: id }) }
  toggleModal = () => { this.setState({ show: !this.state.show }) }

  render() {
    const { subscriptions, currentUser, error, notice, customer } = this.props;
    const { selectedSubscription, show } = this.state;
    console.log(customer);
    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.plan.text}
            buttonUrl={buttons.plan.url}
            currentUser={currentUser}
          />

          <div className="col-12 md-px3 mx-auto py-110 sm-py4" style={{ maxWidth: '1010px' }}>
            <h2 className="center title mb-30">Subscriptions</h2>
            <h2 className="center h2 mb-30">Current plan</h2>
            <Error message={error} />
            <Error message={notice} />
            <div className="mx-auto" style={{ maxWidth: 500 }}>
              {subscriptions.length > 0 ?
                subscriptions.map(subscription => (
                  <div className="border border-violet-red box-shadow-around mb3 p-40 rounded-16 sm-p3">
                    <div className="flex flex-justify sm-block">
                      <p className="title m0 pr3 sm-center sm-mb2">{subscription.plan.nickname}</p>
                      <p className="right-align sm-center sm-mb3">
                        <span className="h2">{subscription.plan.amount_decimal/100}$</span>
                        <br />
                        {subscription.plan.interval}
                      </p>
                    </div>

                    <p className="border-bottom border-gallery mb2 pb2 sm-center">For entrepreneurs and solopreneurs</p>

                    <div className="flex flex-center flex-justify mb2 sm-block">
                      <p className="sm-mb2">
                        Next payment: <br className="hidden sm-show" />
                        {new Date(subscription.current_period_end).toLocaleDateString('en-US')} - ( <span className="underline">{subscription.status}</span> )
                      </p>

                      {subscription.status === 'active'
                        && <button
                          className="btn btn--primary btn--primary--wisp-pink sm-col-12"
                          onClick={(e) => {
                            e.preventDefault()
                            this.setSelectedSubscription(subscription.id)
                            this.toggleModal()
                          }}
                          type="submit"
                        >
                          Cancel
                        </button>
                      }
                    </div>

                    <div className="flex flex-center flex-justify sm-block">

                      {customer ? <p className="sm-mb2">
                        Card: <br className="hidden sm-show" />
                        **** **** **** {customer.last4}
                      </p> :
                        <p className="sm-mb2">No credit card, please update!</p>
                      }



                      <a
                        className="btn btn--primary btn--primary--wisp-pink sm-col-12"
                        href="/credit_cards"
                      >
                        Change card
                      </a>
                    </div>
                  </div>
                ))
                : <p className="center">No active subscription</p>}

              <div className="flex flex-justify-center mt3">
                <a className="btn btn--primary" href="/">Go to Dashboard</a>
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={show}
          text="You are about to cancel your subscription. If you select OK, you will not renew your subscription when the current subscription period is over. Are you sure?"
          title="Cancel subscription"
        >
          <div className="flex mxn2">
            <div className="col-6 px2">
              <form action={`/subscriptions/${selectedSubscription}/cancel`} method="post">
                <button className="btn btn--primary col-12" type="submit">Ok</button>
              </form>
            </div>

            <div className="col-6 px2">
              <button className="btn btn--primary btn--primary--wisp-pink col-12" onClick={this.toggleModal} type="button">Cancel</button>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Index
